import { classnames } from '@core/utils/css';
import React, { Component, ExoticComponent, memo, ReactNode, useEffect, useState, useMemo, ReactElement } from 'react';
import { Card, CardHeader, Collapse } from 'reactstrap';

export interface AccordianMapping {
  title: string | ReactNode;
  titleStyle?: React.CSSProperties;
  component: Component<any> | ExoticComponent<any>;
  props?: any;
  active?: boolean;
}

export interface AccordianProps {
  tabs: AccordianMapping[];
  initialIndex?: number;
  onChange?(index: number): void;
  onClick?(index: number): void;
  isLazy?: boolean;
  height?: string;
}

export const Accordian = memo((props: AccordianProps) => {
  const { tabs, onChange, isLazy = false, height = null } = props;

  const [activeTabIndex, setActiveTabIndex] = useState<number>(props.initialIndex || 0);

  useEffect(() => {
    onChange && onChange(activeTabIndex);
  }, [activeTabIndex, onChange]);

  return (
    <div id="accordion" className="accordion">
      {tabs.map((tab, index) => {
        const TabComponent = tab.component as any;
        const isActive = tab.active ? true : activeTabIndex === index;
        return (
          <Card key={index} className="accordion-item mb-1">
            <CardHeader
              onClick={() => {
                setActiveTabIndex(isActive ? -1 : index);
                props.onClick && props.onClick(index);
              }}
              className={
                ' accordion-header p-3 ' +
                classnames({
                  active: isActive,
                })
              }
            >
              <h6 className="m-0 font-14 w-100">
                <span style={{ cursor: 'pointer', ...tab.titleStyle }}>{tab.title}</span>
              </h6>
            </CardHeader>

            <Collapse isOpen={isActive}>
              <div className="accordion-body p-3" style={{ height: height ?? '', overflowY: 'auto' }}>
                <TabComponent key={index} {...tab.props} />
              </div>
            </Collapse>
          </Card>
        );
      })}
    </div>
  );
});
